import { useDispatch } from 'react-redux';
import { WebCommandEnum } from '../models/commands';
import { setRoboticMowerBleConnected } from '../store/reducer';
import { useConsumeWebCommand } from './use-consume-web-command';

const useMowerBleConnectionStatus = () => {
  const dispatch = useDispatch();
  useConsumeWebCommand(WebCommandEnum.RoboticMowerConnectionUpdated, (command) => {
    if (command.params?.assetId && command.params?.status) {
      dispatch(
        setRoboticMowerBleConnected({
          assetId: command.params.assetId,
          status: command.params.status,
        })
      );
    }
  });
};

export default useMowerBleConnectionStatus;
